import axios from 'axios'
import Vue from 'vue'

window.axios = axios

window.$http = Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API || '/',
  withCredentials: true,
  headers: { }
})


$http.interceptors.response.use(function (response) {
  return response
}, function (err) {
  if (err.response) {
    if (err.response.status == 401) {
      alert('Sessione scaduta')
      Vue.$router.push({ name: 'pageLogin' })
    } else if (err.response.status != 400) {
      alert(`Errore [${err.response.status}]: ${err.response.data.message}`)
    }
  } else if (err.request) {
    alert('Errore nella richiesta')
  } else {
    alert('Errore di connessione: ' + err.message)
  }
  return Promise.reject(err)
})
